export const dev_baseUrl = process.env.REACT_APP_API_URL || 'https://tuleraapidev.rebiz.com/api';

